import { useToastStore } from '../stores/toastStore'
import type { ToastType } from '../stores/toastStore'

const icons: Record<ToastType, string> = {
  success: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  error: 'M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z',
  info: 'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
}

const colors: Record<ToastType, string> = {
  success: 'border-green-500 text-green-500',
  error: 'border-red-500 text-red-500',
  info: 'border-accent text-accent',
}

export default function Toast() {
  const { toasts, removeToast } = useToastStore()

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          onClick={() => removeToast(toast.id)}
          className={`pointer-events-auto flex items-center gap-3 bg-surface border rounded-xl px-4 py-3 shadow-lg cursor-pointer animate-slide-up ${colors[toast.type]}`}
        >
          <svg className="w-5 h-5 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d={icons[toast.type]} />
          </svg>
          <span className="text-sm text-text-primary flex-1">{toast.message}</span>
        </div>
      ))}
    </div>
  )
}
